import { useState, useNavigate, axios, Button, Input, Card, CardContent, CardHeader, CardTitle, CardDescription, Label, Loader2, LOGO_URL, API, toast } from "@/pages/shared";

export const AdminLogin = () => {
  // Two modes:
  //  • "account"  — use your normal user-account email + password (modern, rotates via "Forgot Password")
  //  • "legacy"   — use the env-set ADMIN_PASSWORD (backwards compat with old bookmarks)
  const [mode, setMode] = useState("account");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const body = mode === "account" ? { email, password } : { password };
      await axios.post(`${API}/admin/login`, body, { withCredentials: true });
      toast.success("Admin access granted");
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Invalid admin credentials");
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center hero-glow px-4">
      <Card className="glass max-w-md w-full">
        <CardHeader className="text-center">
          <img src={LOGO_URL} alt="Creatara - Admin Panel Access" className="w-16 h-16 rounded-xl mx-auto mb-4" />
          <CardTitle>Admin Access</CardTitle>
          <CardDescription>
            {mode === "account"
              ? "Sign in with your Creatara account (must have admin privileges)"
              : "Enter the legacy admin password from your environment config"}
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleLogin} className="space-y-4" data-testid="admin-login-form">
            {mode === "account" && (
              <div>
                <Label htmlFor="admin-email">Email</Label>
                <Input
                  id="admin-email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@creatara.ai"
                  className="mt-1 bg-white/5 border-white/10"
                  required
                  data-testid="admin-email-input"
                />
              </div>
            )}
            <div>
              <Label htmlFor="admin-password">Password</Label>
              <Input
                id="admin-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                className="mt-1 bg-white/5 border-white/10"
                required
                data-testid="admin-password-input"
              />
            </div>
            <Button
              type="submit"
              disabled={loading}
              className="w-full btn-primary-glow bg-violet-600 hover:bg-violet-700 rounded-full"
              data-testid="admin-login-submit"
            >
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Access Admin Panel"}
            </Button>
          </form>
          <button
            type="button"
            onClick={() => { setMode(mode === "account" ? "legacy" : "account"); setEmail(""); setPassword(""); }}
            className="w-full mt-3 text-xs text-muted-foreground hover:text-foreground transition-colors"
            data-testid="admin-login-mode-toggle"
          >
            {mode === "account" ? "Use legacy admin password instead" : "← Use account credentials instead"}
          </button>
        </CardContent>
      </Card>
    </div>
  );
};
